<template>
  <div class="form-area">
    <!-- <div class="form-title">
      申請資格聲明<br />Application Eligibility Declaration
    </div> -->
    <!-- 請參閱申請細則內之收入和資產淨值之計算；<br />Please refer to the
      calculation of income and net asset value in the application rules;    -->

    <div class="form-header-desc" v-html="formTitleHtml">

    </div>
    <el-form :model="eligibilityDeclaration" :rules="eligibilityDeclarationRules" ref="eligibilityDeclaration">
      <el-form-item prop="declaration">
        <div class="contact-area" v-for="item in list" :key="item.value">
          <el-checkbox-group v-model="eligibilityDeclaration.declaration">
            <el-checkbox :label="item.value"><span class="declaration-text" v-html="item.label" /></el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>

    <div class="btn-box">
      <el-row>
        <el-col :span="12">
          <el-button type="warning" class="two-btn" round @click="previousSetp">上一步 Back</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="warning" class="two-btn" :disabled="eligibilityDeclaration.declaration.length != list.length"
            round @click="nextSetp">繼續 Next</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {
    filterDeclarationsData
  } from "@/utils/json/utils";
  import {
    eligibilityDeclarationForm,
    getContent
  } from "@/assets/js/api.js";
  export default {
    created() {
      //先取缓存
      this.eligibilityDeclaration.declaration =
        this.Session.get("eligibilityDeclaration") || [];
      //獲取聲明字典
      this.getContent(this.isSingle ? 'PH20006' : 'PH20007');
    },

    data() {
      return {
        eligibilityDeclaration: {
          declaration: [],
        },
        isSingle: this.Session.get("formId") === 1,
        formTitleHtml: "", //表格標題
        list: [], //聲明數組
        // list: filterDeclarationsData(
        //   this.Session.get("formId") === 1
        //     ? "singleEligibilityDeclaration"
        //     : "doubleEligibilityDeclaration"
        // ),

        eligibilityDeclarationRules: {},
      };
    },
    methods: {
      /**
       * 動態獲取聲明數據
       */
      getContent(code) {
        getContent(code).then(res => {
          //根據關鍵字切分 跟admin端約束標準 <p>✔</p> 
          var htmlContextList = res.context.split('<p>✔</p>');
          console.log(htmlContextList)
          this.list = []
          for (var i = 0; i < htmlContextList.length; i++) {
            if (i == 0) {
              this.formTitleHtml = htmlContextList[i];
            } else {
              this.list.push({
                value: String(i - 1),
                label: htmlContextList[i],
              });
            }
          }
        })
      },
      nextSetp() {
        this.Session.set(
          "eligibilityDeclaration",
          this.eligibilityDeclaration.declaration
        );
        eligibilityDeclarationForm({
          eligibilityDeclaration: JSON.stringify(
            this.Session.get("eligibilityDeclaration")
          ),
        }).then((res) => {
          this.$store.dispatch("PREVIOUS_SETP", {
            changeStep: false,
            operateName: "informationPreview",
          });
        });
      },
      previousSetp() {
        this.Session.set(
          "eligibilityDeclaration",
          this.eligibilityDeclaration.declaration
        );
        this.$store.dispatch("PREVIOUS_SETP", {
          changeStep: true,
          //判断一人还是两人申请，返回不同的页面
          operateName: this.isSingle ? "liveEmployment" : "liveEmployment2",
        });
      },
    },
  };

</script>

<style>
  .declaration-text {
    font-weight: 400;
    line-height: 28px;
    font-size: 14px;
    white-space: pre-line;
    font-family: 'IBM Plex Sans', 'Segoe UI', Arial, sans-serif !important;
  }

</style>



// WEBPACK FOOTER //
// src/view/apply/child/declaration.vue